interface FabPopupItemProps {
  icon: React.ReactNode | string;
  onClick: () => void;
  title: string;
}

const FabPopupItem: React.FC<FabPopupItemProps> = ({
  icon,
  title,
  onClick,
  ...props
}) => (
  <button
    type="button"
    className="hover:bg-th-bg! text-brand-navy! flex w-full cursor-pointer items-center gap-3 px-4! py-3! text-left! font-bold!"
    id={title}
    onClick={onClick}
    {...props}
  >
    {icon}
    {title}
  </button>
);

export default FabPopupItem;
